import styled from '@emotion/styled';

import { colors } from '@/lib/theme';

export const Divider = styled.hr`
	border: 0;
	border-top: 1px solid ${colors.interface.border};
	width: 100%;
	margin: 0;
`;
